<template>
  <div class="tile is-ancestor is-parent">
    <div class="tile is-parent is-8">
      <article class="tile is-child box">
        <p class="title">Detail Info</p>
        <div class="field">
          <label class="label">Type</label>
          <span>{{ value.assetType }}</span>
        </div>
        <div class="field">
          <label class="label">Direction</label>
          <span>{{ value.direction }}</span>
        </div>
        <div class="field">
          <label class="label">Status</label>
          <span>{{ value.status }}</span>
        </div>
        <div class="field">
          <label class="label">Date</label>
          <span>{{ $filters.formatDateTimeLocale(value.sentOn, $userInfo.locale) }}</span>
        </div>
        <div class="field">
          <label class="label">Contact</label>
          <span>{{ value.sendTo }}</span>
        </div>
        <div class="field">
          <label class="label">Quote No.</label>
          <span>{{ value.quoteNoRef }}</span>
        </div>
        <div class="field">
          <label class="label">Claim No.</label>
          <span>{{ value.claimNo }}</span>
        </div>
        <div class="field">
          <label class="label">Rego</label>
          <span>{{ value.rego }}</span>
        </div>
        <!-- <div class="field">
          <label class="label">Cc</label>
          <span>{{ value.cc }}</span>
        </div> -->
        <div class="field">
          <label class="label">Message</label>
          <span style="white-space: pre-wrap;">{{ $filters.replaceBr(value.message) }}</span>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
// import EmailSmsLogService from './EmailSmsLogService'
import StoreMixin from './storeMixin'
import { DateTimeFiltersMixin } from '@/components/mixins/filters'

export default {
  name: 'EmailsmslogDetail',
  // inject: ['$vv'],
  components: {},
  mixins: [DateTimeFiltersMixin, StoreMixin],
  props: {
    value: null,
    isNew: Boolean
  },
  data() {
    return {
      // message: this.value.message.replace(/<br\s*\/?>/mg, '\n') //this.value.message.replace(/(<([^>]+)>)/ig, '\r\n')
    }
  },
  computed: {
    // $v() {
    //   return this.$vv || this.$v
    // }
  },
  watch: {
    value: {
      handler: function (newVal, oldVal) {
        alert(newVal)
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  mounted() {
    // this.$v.detailGroup.$touch()
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.is-divider {
  margin: 1.2em 0;
}
.desc-width {
  width: 60%;
}
</style>
